import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import QuestionOptionsInputs from '../../../../../../../containers/checklists/questionOptions/QuestionOptionsInputs'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'

const MultiOptionsSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange, removeChildConditionToSelectedQuestion } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderOptions = shouldRender('options')

  const { randomIdAfterUndo } = useChecklistFormActions()

  if (!shouldRenderOptions) return false

  const handleRemove = item => {
    if (!selectedQuestion?.childDisplayConditions) return

    const removedIndex = selectedQuestion?.childDisplayConditions?.findIndex(displayCondition => {
      return displayCondition.findIndex(condition => {
        return condition?.value.findIndex(value => value.reference === item.reference)
      })
    })

    if (removedIndex >= 0) {
      removeChildConditionToSelectedQuestion(removedIndex)
    }
  }

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('multipleChoiceOptions')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <QuestionOptionsInputs
        key={randomIdAfterUndo}
        onRemove={handleRemove}
        onChange={handleSelectedQuestionChange('options')}
        onChangeGlobalOptions={handleSelectedQuestionChange('questionOptionsId')}
        question={selectedQuestion}
      />
      <Separator weight={2} />
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />
    </>
  )
}

export default MultiOptionsSection
